import React, { Component } from 'react';

import { Routes } from '../config/routes';

export default class Body extends Component {
  render() {
    return (
      <div className="rel outer-container index">
        <Routes />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/body.js